import { useEffect, useState } from "react";
import { app } from "@microsoft/teams-js";

export type TeamsTheme = "default" | "dark" | "contrast";

export function useTeamsTheme(): TeamsTheme {
  const [theme, setTheme] = useState<TeamsTheme>("default");

  useEffect(() => {
    let cancelled = false;
    app
      .getContext()
      .then((ctx) => {
        if (cancelled) return;
        const t = (ctx.app.theme as TeamsTheme) || "default";
        setTheme(t);
      })
      .catch(() => {});

    try {
      app.registerOnThemeChangeHandler((t) => {
        setTheme((t as TeamsTheme) || "default");
      });
    } catch {
      // Outside Teams (local dev) — ignore
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return theme;
}
